export default __webpack_public_path__ + "static/media/slider-share-M.30fda5af.png";